var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.currentComponet,{tag:"component",on:{"onAdd":_vm.handleEdit,"onGoBack":_vm.handleGoBack,"onCouponList":_vm.handleCouponList}})}
var staticRenderFns = []

export { render, staticRenderFns }